import { CREATE_AGENT_LOG } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { AgentLog } from './getAgentLogs';

interface AddAgentWorkLogResponse {
  success: boolean;
  message?: string;
  log?: AgentLog;
}

type AddAgentWorklogPayload = Omit<AgentLog, '_id' | 'createdAt' | 'updatedAt'>;

const addAgentWorklogApi = async (
  payload: AddAgentWorklogPayload
): Promise<AddAgentWorkLogResponse> => {
  try {
    const response = await makeAuthenticatedRequest(CREATE_AGENT_LOG, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update agent worklog failed:', error);
    throw error;
  }
};

export {
  addAgentWorklogApi,
  type AddAgentWorkLogResponse,
  type AddAgentWorklogPayload,
};
